import React, { useEffect } from "react";
import TitleProgressBar from "../../../../components/progress-bars/TitleProgressBar";
import BaseModal from "../../../../components/modals/BaseModal";

const SaveProgressModal = ({ currentPercentage, currentMessage, onClose }) => {
  useEffect(() => {
    if (currentPercentage === 100) {
      setTimeout(() => {
        onClose();
      }, 1000);
    }
  }, [currentMessage]);

  const headerChildren = (
    <div className="flex items-center justify-between w-full">
      <h2 className="text-[14px] md:text-[16px] lg:text-[18px] font-bold">Saving workspace</h2>
    </div>
  );

  const bodyChildren = (
    <div className="flex flex-col justify-center items-center">
      <TitleProgressBar
        percentage={currentPercentage}
        title={currentMessage}
        color="var(--primary-color)"
      />
    </div>
  );

  return (
    <BaseModal
      headerChildren={headerChildren}
      bodyChildren={bodyChildren}
      showClose={false}
      width="w-3/4 md:w-3/4 lg:w-1/2 xl:w-[37%]"
      show={true}
    />
  );
};

export default SaveProgressModal;
